import React from 'react';
import { Calendar, FileSearch, Users, Rocket, Trophy, Globe } from 'lucide-react';
import { selectionProcess } from '../../data/mock';

const icons = [Calendar, FileSearch, Users, Rocket, Trophy, Globe];

const SelectionSection = () => {
  return (
    <section data-testid="selection-section" className="relative py-20 md:py-32 bg-cream overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_70%,_#3E4441_1px,_transparent_1px)] bg-[length:48px_48px]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-dwarfpony text-sm font-semibold tracking-wider uppercase mb-4">
            Join Us
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-deepwalnut mb-6">
            Selection <span className="text-richolive">Process</span>
          </h2>
          <p className="text-heavyrain text-lg max-w-2xl mx-auto">
            Your journey from application to representing India at the global stage
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Connecting Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-dwarfpony via-richolive to-dwarfpony -translate-y-1/2" />

          <div className="grid sm:grid-cols-2 lg:grid-cols-6 gap-6">
            {selectionProcess.map((step, index) => {
              const Icon = icons[index];
              return (
                <div
                  key={index}
                  className="relative bg-cream border border-pragmatic/30 rounded-2xl p-6 hover:border-dwarfpony hover:shadow-lg transition-all group"
                >
                  {/* Icon */}
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-pragmatic/30 to-richolive/20 flex items-center justify-center mb-4 mx-auto lg:mx-0 group-hover:from-dwarfpony/30 group-hover:to-richolive/30 transition-colors">
                    <Icon className="w-6 h-6 text-dwarfpony" />
                  </div>

                  {/* Month Badge */}
                  <span className="inline-block text-richolive text-xs font-semibold uppercase tracking-wider mb-2">
                    {step.month}
                  </span>

                  {/* Title */}
                  <h3 className="text-deepwalnut font-bold text-base mb-2">{step.title}</h3>

                  {/* Description */}
                  <p className="text-heavyrain text-sm leading-relaxed">{step.description}</p>

                  {/* Step Number */}
                  <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-gradient-to-br from-dwarfpony to-dwarfpony-dark flex items-center justify-center text-white font-bold text-sm shadow-lg shadow-dwarfpony/30">
                    {index + 1}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SelectionSection;
